module.exports = __webpack_public_path__ + "img/76_15.9f48c2b0.png";